import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class AppService {

  private serviceName = 'api/authentication';
  constructor(private http: Http, private cookieService: CookieService) {

  }

  CheckLogin(token: string) {
    return this.http.get(`${this.serviceName}/IsUserLoggedIn?token=` + token, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  Logout(token: string) {
    return this.http.get(`${this.serviceName}/Logout?token=` + token, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/app/app.service.ts